var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentresponseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5003 18.9584H7.50033C2.97533 18.9584 1.04199 17.0251 1.04199 12.5001V7.50008C1.04199 2.97508 2.97533 1.04175 7.50033 1.04175H11.667C12.0087 1.04175 12.292 1.32508 12.292 1.66675C12.292 2.00841 12.0087 2.29175 11.667 2.29175H7.50033C3.65866 2.29175 2.29199 3.65841 2.29199 7.50008V12.5001C2.29199 16.3417 3.65866 17.7084 7.50033 17.7084H12.5003C16.342 17.7084 17.7087 16.3417 17.7087 12.5001V8.33342C17.7087 7.99175 17.992 7.70842 18.3337 7.70842C18.6753 7.70842 18.9587 7.99175 18.9587 8.33342V12.5001C18.9587 17.0251 17.0253 18.9584 12.5003 18.9584Z",
    fill: "#353535"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3337 8.9584H15.0003C12.1503 8.9584 11.042 7.85007 11.042 5.00007V1.66674C11.042 1.41674 11.192 1.18341 11.4253 1.09174C11.6587 0.991739 11.9253 1.05007 12.1087 1.22507L18.7753 7.89174C18.9503 8.06674 19.0087 8.34174 18.9087 8.57507C18.8087 8.8084 18.5837 8.9584 18.3337 8.9584ZM12.292 3.17507V5.00007C12.292 7.15007 12.8503 7.70841 15.0003 7.70841H16.8253L12.292 3.17507Z",
    fill: "#353535"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.833 11.4583H5.83301C5.49134 11.4583 5.20801 11.1749 5.20801 10.8333C5.20801 10.4916 5.49134 10.2083 5.83301 10.2083H10.833C11.1747 10.2083 11.458 10.4916 11.458 10.8333C11.458 11.1749 11.1747 11.4583 10.833 11.4583Z",
    fill: "#353535"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16634 14.7917H5.83301C5.49134 14.7917 5.20801 14.5084 5.20801 14.1667C5.20801 13.8251 5.49134 13.5417 5.83301 13.5417H9.16634C9.50801 13.5417 9.79134 13.8251 9.79134 14.1667C9.79134 14.5084 9.50801 14.7917 9.16634 14.7917Z",
    fill: "#353535"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentresponseIcon);
export default __webpack_public_path__ + "static/media/documentresponse_icon.d1968cb467e3c709b1282ac328261ebe.svg";
export { ForwardRef as ReactComponent };